'use strict';

/**
 * DO NOT MODIFY
 * Generated from yarn nx run illustrations:sync
 */

/**
 * Currently used on web for interpolating the URL to CDN hosted asset using the name and version number.
 *
 * For example, given the following SpotRectangle versionMap, '{ someIllustration: 2 }', and
 * JSX such as '<SpotRectangle name="someIllustration />' will result in an image with the following URL:
 *
 * 'https://static-assets.coinbase.com/design-system/illustrations/spotRectangle/light/someIllustration-2.svg
 *
 * In addition, this file is used to populate SpotRectangle stories in percy, so the sort order based on createdAt is important.
 */
const versionMap = {
  accessToAdvancedCharts: 4,
  ratMigrationerror: 2,
  ethAddress: 2,
  walletReconnectSuccess: 3,
  primePriceLadder: 2,
  margin: 4,
  trade: 2,
  primeTradePreferences: 3,
  ledgerFailed: 2,
  fileYourCryptoTaxes: 2,
  ledgerSignatureRejected: 2,
  apiKey: 3,
  primeStaking: 3,
  diamond: 4,
  marginWarning: 4,
  ratMigration: 2,
  downloadingStatement: 2,
  ratDashboard: 2,
  leverage: 3,
  cardBoosted: 2,
  noTransactions: 2,
  browserHistory: 2,
  login: 3,
  primeEarn: 3,
  primeDeFi: 3,
  yieldHolding: 2,
  coinbaseOneLogo: 4,
  transferCoins: 2,
  bridging: 2,
  coinbaseOnePhoneLightning: 3,
  creditCardExcitement: 2,
  sendingCrypto: 2,
  downloadCoinbaseWalletArrow: 3,
  primeOrderConfirmation: 2,
  focusLimitOrders: 3,
  advancedTradeCharts: 1,
  switchAdvancedToSimpleTrading: 4,
  linkCoinbaseWallet: 3,
  portfolioOverview: 3,
  sendCryptoFaster: 2,
  uob: 3,
  highFees: 4,
  governance: 3,
  referralsBonus: 2,
  fileYourCryptoTaxesCheck: 2,
  giftBoxRewards: 4,
  futures: 3,
  nft: 2,
  addBank: 3,
  currency: 2,
  cardWaitlist: 2,
  protectedNotes: 2,
  emptyTrading: 2,
  emptyNfts: 2,
  transferFunds: 3,
  clawMachinePig: 3,
  ratFoundWallet: 3,
  multicoinSupport: 2,
  crossBorderPayments: 2,
  noFees: 3,
  poweredByEthereum: 3,
  decentralizedWebWeb3: 3,
  secureAndTrusted: 2,
  getStartedInMinutes: 4,
  secureStorage: 3,
  mining: 3,
  multiPlatformMobileAppBrowserExtension: 3,
  stableValue: 3,
  staking: 3,
  selfCustody: 3,
  startToday: 3,
  stayInControlSelfHostedWalletsStorage: 3,
  stressTestedColdStorage: 3,
  walletSecurity: 3,
  blockchain: 3,
  borrowWallet: 2,
  congratulationsOnEarningCrypto: 3,
  cryptoPortfolio: 2,
  didDecentralizedIdentity: 2,
  semiCustodial: 3,
  retailUSDCRewards: 3,
  coinbaseOneRewards: 2,
  taxesDetails: 3,
  gainsAndLosses: 3,
  hardwareWallets: 3,
  portfolioPerformance: 3,
  cryptoAssets: 4,
  cryptoWallet: 3,
  insuranceProtection: 3,
  basedInUsa: 3,
  advancedTradingChartsIndicatorsCandles: 2,
  layeredNetworks: 3,
  encryptedEverything: 3,
  completeAQuiz: 3,
  browserExtension: 3,
  cryptoForBeginners: 4,
  moneyDecentralized: 2,
  defiDecentralizedTradingExchange: 3,
  sidechain: 3,
  watchVideos: 3,
  collectingNfts: 3,
  quickAndSimple: 3,
  linkingYourWalletToYourCoinbaseAccount: 4,
  earn: 2,
  digitalCollectibles: 2,
  gasFeesNetworkFees: 3,
  trendingHotAssets: 2,
  optInPushNotificationsEmail: 3,
  invest: 3,
  multipleAccountsWalletsForOneUser: 3,
  cryptoEconomy: 2,
  decentralization: 4,
  defiDecentralizedBorrowingLending: 2,
  shareOnSocialMedia: 2,
  backedByUsDollar: 3,
  ethStakingRewards: 3,
  ethWrappedStakingRewards: 3,
  cbEth: 2,
  transferEth: 2,
  ethStakeOrWrap: 2,
  eth2SellSend: 2,
  ethStakingMovement: 2,
  earnToLearn: 3,
  globalTransactions: 3,
  secureGlobalTransactions: 3,
  referralsBitcoin: 3,
  walletReconnect: 3,
  p2pPayments: 3,
  connectWalletTutorial: 2,
  wrapEth: 3,
  eth2SendSell: 3,
  ethTrading: 4,
  ethTradingTwo: 3,
  eth2SendSellTwo: 2,
  ethStakeOrWrapTwo: 2,
  wrapEthTwo: 2,
  update: 2,
  openEmail: 2,
  readyToTrade: 2,
  defiEarn: 2,
  cryptoApps: 2,
  coinbaseOneSavingFunds: 2,
  freeBtc: 2,
  estimatedAmount: 2,
  coinbaseFees: 2,
  holdCrypto: 2,
  securityShield: 2,
  addPhoneNumber: 2,
  tradeImmediately: 2,
  documentSuccess: 2,
  coinbaseCardLock: 2,
  commerceInvoices: 2,
  commerceAccounting: 1,
  defiRisk: 2,
  verifyInfo: 2,
  contactsListWarning: 2,
  earnInterest: 2,
  notificationsAlt: 2,
  appTrackingTransparency: 2,
  walletNotifications: 2,
  phoneNumber: 2,
  verifyEmail: 2,
  cryptoAndMore: 2,
  automaticPayments: 2,
  coinbaseOneDiscountedAmount: 2,
  coinbaseCardPocket: 2,
  advancedTradingUi: 1,
  defiHow: 2,
  exploreDecentralizedApps: 2,
  bigBtc: 2,
  onTheList: 2,
  documentCertified: 2,
  advancedTrading: 2,
  holdingCrypto: 2,
  scanCode: 1,
  uploadDocument: 0,
  referralsCoinbaseOne: 0
};
module.exports = versionMap;
//# sourceMappingURL=versionMap.js.map
